import Select, { components }  from 'react-select';

const CustomOption = (props) => {
    let option = props.data;
	return (
        <div>
            <components.Option {...props}>
                <span className="black">{option.label}</span>        
            </components.Option>     
        </div>
    )
}

export default function FundSelector(props) {
   return (
        <div className="fund-selection">
            <span>{props.text}</span>
            <div>
                <Select
                    placeholder="BlackRock High Yield Bond Fund"
                    className="fund-selector"
                    classNamePrefix="fund-selector"
                    isClearable={false}
                    isSearchable={false}
                    components={{ Option: CustomOption }}  
					value={props.value}                 
                    options={props.options}
                    onChange={(value) => {
                        props.onChange(value);
                    }}
                />
            </div>
        </div>
    )
}